import authApi from "@/api/modules/auth";
import noticeApi from "@/api/modules/notice";
import productApi from "@/api/modules/product";
import eventApi from "@/api/modules/event";
import youtubeApi from "@/api/modules/youtube";
import customerInquireApi from "@/api/modules/customerInquire";
import faqApi from "@/api/modules/faq";
import categoryApi from "@/api/modules/category";
import commonApi from "@/api/modules/common";
import lectureApi from "@/api/modules/lecture";
import solutionApi from "@/api/modules/solution";
import afterserviceApi from "@/api/modules/afterservice";
import downloadApi from "@/api/modules/download";
import qnaApi from "@/api/modules/qna";
import praiseComplainApi from "./modules/praiseComplain";

export const api = {
    auth: authApi,
    notice: noticeApi,
    product: productApi,
    event: eventApi,
    youtube: youtubeApi,
    customerInquire: customerInquireApi,
    faq: faqApi,
    solution: solutionApi,
    afterservice: afterserviceApi,
    lecture: lectureApi,
    common: commonApi,
    category: categoryApi,
    download: downloadApi,
    qna: qnaApi,
    pc: praiseComplainApi,
};
